import { render, staticRenderFns } from "./HorarioTooltip.vue?vue&type=template&id=af541632&scoped=true"
import script from "./HorarioTooltip.vue?vue&type=script&lang=js"
export * from "./HorarioTooltip.vue?vue&type=script&lang=js"
import style0 from "./HorarioTooltip.vue?vue&type=style&index=0&id=af541632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af541632",
  null
  
)

export default component.exports